export enum MARKETPLACE_CATEGORY {
    FOOD = "food",
    INSTAMART = "instamart",
    STORES = "store",
    PUDO = "pudo",
    // this is for order anything
    CUSTOM = "custom",
    HANDPICKED = "HANDPICKED",
    INSTAMAX = "instamax",
    INSANELYGOOD = "insanelygood",
    ASSURE = "assure",
    JUST = "just",
    CBCC = "cbcc",
    GIFTING = "gifting",
    DINING = "dining",
    DINEOUT = "dining",
}

export enum MARKETPLACE_BUSINESS_LINE {
    REGULAR = "regular",
    POP = "pop",
    EDIT_ORDER = "edit_order",
    SWIGGY_MONEY = "swiggy_money",
    SUBSCRIPTION = "subscription",
    POST_ORDER_TIP = "post_order_tipping",
    SWIGGY_SUPER = "swiggy_super",
    DASH = "dash",
    ASSURE = "assure",
    JUST = "just",
    DINEOUT = "dineout",
    PAY_ON_DELIVERY = "pay_on_delivery",
    HANDPICKED = "handpicked",
    SWIGGY_ONE = "swiggy_one",
    CBCC = "cbcc",
    GIFTING = "gifting",
}

export enum MARKETPLACE_ID {
    CHECKOUT = "CHECKOUT",
    SWIGGY_MONEY = "SWIGGY_MONEY",
    DASH = "DASH",
    DINEOUT = "DINEOUT",
    ASSURE = "SCOOTSY",
    JUST = "JUST",
    CBCC = "cbcc",
    GIFTING = "GIFTING",
    LIQUOR = "LIQUOR",
}
